/**
 * Prefix for all stats metrics (count and time).
 * @type {String}
 */
exports.STATS_PREFIX = 'services.layout_service';

/**
 * Prefix for all in memory size metrics.
 * @type {String}
 */
module.exports.DATA_SIZE = 'data_size';
